(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["k-artisan-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initArtisanCarousel(root) {
    if (!root || root.dataset.kacInit === 'true') return;
    root.dataset.kacInit = 'true';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-kac-slide]'));
    var navItems = Array.prototype.slice.call(root.querySelectorAll('[data-kac-nav]'));
    if (!slides.length) return;
    var current = 0;
    var timer = null;
    var interval = (parseInt(root.dataset.interval, 10) || 7) * 1000;
    function activate(index) {
      current = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      navItems.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
      });
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function start() {
      stop();
      if (root.dataset.autorotate !== 'true' || slides.length < 2) return;
      timer = setInterval(function () {
        if (!root.isConnected) {
          stop();
          return;
        }
        activate((current + 1) % slides.length);
      }, interval);
    }
    navItems.forEach(function (item, i) {
      item.addEventListener('click', function () {
        activate(i);
        start();
      });
    });
    start();
  }
  function initAllArtisanCarousels(scope) {
    (scope || document).querySelectorAll('.k-ac').forEach(function (el) {
      initArtisanCarousel(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllArtisanCarousels(document);
    });
  } else {
    initAllArtisanCarousels(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAllArtisanCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-audio-row"] && !Shopify.designMode) return;
  try {
    
(function () {
  var players = [];
  function initAudioRow(root) {
    if (!root || root.dataset.karInit === 'true') return;
    root.dataset.karInit = 'true';
    var url = root.dataset.audioUrl;
    var toggle = root.querySelector('[data-kar-toggle]');
    if (!toggle || !url) return;
    var audio = null;
    var state = {
      pause: function () {
        if (audio && !audio.paused) {
          audio.pause();
        }
        root.classList.remove('is-playing');
      }
    };
    players.push(state);
    toggle.addEventListener('click', function () {
      if (!audio) {
        audio = new Audio(url);
        audio.addEventListener('ended', function () {
          root.classList.remove('is-playing');
        });
      }
      if (audio.paused) {
        players.forEach(function (other) {
          if (other !== state) other.pause();
        });
        var playPromise = audio.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {
            root.classList.remove('is-playing');
          });
        }
        root.classList.add('is-playing');
      } else {
        audio.pause();
        root.classList.remove('is-playing');
      }
    });
  }
  function initAllAudioRows(scope) {
    (scope || document).querySelectorAll('.k-ar').forEach(function (el) {
      initAudioRow(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllAudioRows(document);
    });
  } else {
    initAllAudioRows(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAllAudioRows(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-featured-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFeaturedTabs(root) {
    if (!root || root.dataset.kftInit === 'true') return;
    root.dataset.kftInit = 'true';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-kft-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-kft-panel]'));
    if (!panels.length) return;
    var current = 0;
    var timer = null;
    var interval = (parseInt(root.dataset.interval, 10) || 5) * 1000;
    function activate(index) {
      current = index;
      tabs.forEach(function (tab, i) {
        tab.classList.toggle('is-active', i === index);
      });
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === index);
      });
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function start() {
      stop();
      if (root.dataset.autorotate !== 'true' || panels.length < 2) return;
      timer = setInterval(function () {
        if (!root.isConnected) {
          stop();
          return;
        }
        activate((current + 1) % panels.length);
      }, interval);
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i);
        start();
      });
    });
    start();
  }
  function initAllFeaturedTabs(scope) {
    (scope || document).querySelectorAll('.k-ft').forEach(function (el) {
      initFeaturedTabs(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllFeaturedTabs(document);
    });
  } else {
    initAllFeaturedTabs(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAllFeaturedTabs(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-image-player"] && !Shopify.designMode) return;
  try {
    
(function () {
  function formatTime(seconds) {
    if (!isFinite(seconds) || seconds < 0) seconds = 0;
    var total = Math.floor(seconds);
    var minutes = Math.floor(total / 60);
    var rest = total % 60;
    return (minutes < 10 ? '0' + minutes : String(minutes)) + ':' + (rest < 10 ? '0' + rest : String(rest));
  }
  function initImagePlayer(root) {
    if (!root || root.dataset.kipInit === 'true') return;
    root.dataset.kipInit = 'true';
    var media = root.querySelector('[data-kip-media]');
    var desktopVideo = root.querySelector('video.k-ip__video--desktop');
    var mobileVideo = root.querySelector('video.k-ip__video--mobile');
    var playButton = root.querySelector('[data-kip-play]');
    var progress = root.querySelector('[data-kip-progress]');
    var played = root.querySelector('[data-kip-played]');
    var timeLabel = root.querySelector('[data-kip-time]');
    if (!media || !playButton || !progress || !played || !timeLabel) return;
    if (!desktopVideo && !mobileVideo) return;
    var mq = window.matchMedia('(max-width: 767px)');
    function activeVideo() {
      if (mq.matches && mobileVideo) return mobileVideo;
      return desktopVideo || mobileVideo;
    }
    function updateProgress() {
      var video = activeVideo();
      if (!video) return;
      var duration = video.duration || 0;
      var percent = duration ? (video.currentTime / duration) * 100 : 0;
      played.style.width = percent + '%';
      timeLabel.textContent = formatTime(video.currentTime) + ' / ' + formatTime(duration);
    }
    [desktopVideo, mobileVideo].forEach(function (video) {
      if (!video) return;
      video.addEventListener('timeupdate', function () {
        if (video === activeVideo()) updateProgress();
      });
      video.addEventListener('loadedmetadata', function () {
        if (video === activeVideo()) updateProgress();
      });
      video.addEventListener('play', function () {
        if (video === activeVideo()) root.classList.add('is-playing');
      });
      video.addEventListener('pause', function () {
        if (video === activeVideo()) root.classList.remove('is-playing');
      });
    });
    playButton.addEventListener('click', function (event) {
      event.stopPropagation();
      var video = activeVideo();
      if (!video) return;
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    });
    media.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-kip-play]')) return;
      var video = activeVideo();
      if (!video) return;
      if (!video.paused) video.pause();
    });
    progress.addEventListener('click', function (event) {
      var video = activeVideo();
      if (!video || !video.duration) return;
      var rect = progress.getBoundingClientRect();
      var ratio = (event.clientX - rect.left) / rect.width;
      ratio = Math.min(1, Math.max(0, ratio));
      video.currentTime = ratio * video.duration;
      updateProgress();
    });
    function onBreakpointChange() {
      if (desktopVideo && !desktopVideo.paused) desktopVideo.pause();
      if (mobileVideo && !mobileVideo.paused) mobileVideo.pause();
      root.classList.remove('is-playing');
      updateProgress();
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', onBreakpointChange);
    } else if (mq.addListener) {
      mq.addListener(onBreakpointChange);
    }
    updateProgress();
  }
  function initAllImagePlayers(scope) {
    (scope || document).querySelectorAll('.k-ip').forEach(function (el) {
      initImagePlayer(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllImagePlayers(document);
    });
  } else {
    initAllImagePlayers(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAllImagePlayers(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-new-drops"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initNewDrops(root) {
    if (!root || root.dataset.kndReady === 'true') return;
    root.dataset.kndReady = 'true';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-knd-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-knd-thumb]'));
    if (!slides.length) return;
    var current = 0;
    var timer = null;
    var interval = parseInt(root.dataset.interval, 10) || 3000;
    function activate(index) {
      current = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function start() {
      stop();
      if (root.dataset.autorotate !== 'true' || slides.length < 2) return;
      timer = setInterval(function () {
        if (!root.isConnected) {
          stop();
          return;
        }
        activate((current + 1) % slides.length);
      }, interval);
    }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        activate(i);
        start();
      });
    });
    start();
  }
  function initAllNewDrops() {
    document.querySelectorAll('.k-new-drops').forEach(function (el) {
      initNewDrops(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllNewDrops);
  } else {
    initAllNewDrops();
  }
  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('.k-new-drops');
    if (el) initNewDrops(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KEY = 'k_recently_viewed';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* private mode / quota — recently viewed is a nicety, never block the page */
    }
  }

  function init(root) {
    if (root.dataset.krvReady === 'true') return;
    root.dataset.krvReady = 'true';

    var grid = root.querySelector('[data-k-rv-grid]');
    if (!grid) return;

    var limit = parseInt(root.dataset.limit, 10) || 10;
    var list = read();
    var currentHandle = root.dataset.current || '';

    if (currentHandle) {
      list = list.filter(function (item) {
        return item && item.handle !== currentHandle;
      });
      list.unshift({
        handle: currentHandle,
        title: root.dataset.currentTitle || '',
        url: root.dataset.currentUrl || '',
        price: root.dataset.currentPrice || '',
        image: root.dataset.currentImage || '',
      });
      write(list.slice(0, limit + 1));
    }

    var visible = list
      .filter(function (item) {
        return item && item.handle && item.handle !== currentHandle && item.url;
      })
      .slice(0, limit);

    if (!visible.length) return;

    var frag = document.createDocumentFragment();
    visible.forEach(function (item) {
      var card = document.createElement('a');
      card.className = 'k-rv__card';
      card.href = item.url;

      var media = document.createElement('div');
      media.className = 'k-rv__media';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        media.appendChild(img);
      }
      card.appendChild(media);

      var title = document.createElement('p');
      title.className = 'k-rv__title';
      title.textContent = item.title || '';
      card.appendChild(title);

      if (item.price) {
        var price = document.createElement('p');
        price.className = 'k-rv__price';
        price.textContent = item.price;
        card.appendChild(price);
      }

      frag.appendChild(card);
    });

    grid.appendChild(frag);
    root.hidden = false;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-k-recently-viewed]').forEach(init);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlideshow(root) {
    if (root.dataset.kSlideshowInit === 'true') return;
    root.dataset.kSlideshowInit = 'true';
    var track = root.querySelector('[data-k-track]');
    if (!track) return;
    var count = track.children.length;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-k-dot]'));
    var index = 0;
    var delay = (parseInt(root.dataset.autoplay, 10) || 6) * 1000;
    var timer = null;
    var startX = 0;
    var deltaX = 0;
    var dragging = false;
    var moved = false;

    function setTransform(offset, instant) {
      track.style.transition = instant ? 'none' : '';
      track.style.transform = 'translateX(calc(' + index * -100 + '% + ' + (offset || 0) + 'px))';
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function goTo(i) {
      index = ((i % count) + count) % count;
      setTransform(0, false);
      updateDots();
    }

    function next() {
      goTo(index + 1);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (count > 1) {
        timer = setInterval(next, delay);
      }
    }

    function dragStart(x) {
      if (count < 2) return;
      dragging = true;
      moved = false;
      startX = x;
      deltaX = 0;
      stopAutoplay();
    }

    function dragMove(x) {
      if (!dragging) return;
      deltaX = x - startX;
      if (Math.abs(deltaX) > 5) moved = true;
      setTransform(deltaX, true);
    }

    function dragEnd() {
      if (!dragging) return;
      dragging = false;
      if (deltaX < -50) {
        goTo(index + 1);
      } else if (deltaX > 50) {
        goTo(index - 1);
      } else {
        setTransform(0, false);
      }
      deltaX = 0;
      startAutoplay();
    }

    track.addEventListener('touchstart', function (e) {
      dragStart(e.touches[0].clientX);
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      dragMove(e.touches[0].clientX);
    }, { passive: true });
    track.addEventListener('touchend', dragEnd);
    track.addEventListener('mousedown', function (e) {
      e.preventDefault();
      dragStart(e.clientX);
    });
    window.addEventListener('mousemove', function (e) {
      dragMove(e.clientX);
    });
    window.addEventListener('mouseup', dragEnd);
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
    track.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        moved = false;
      }
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    root.kSlideshowStop = stopAutoplay;
    startAutoplay();
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.k-slideshow[data-section-id]');
    Array.prototype.forEach.call(nodes, initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target.querySelectorAll) return;
    var nodes = e.target.querySelectorAll('.k-slideshow[data-section-id]');
    Array.prototype.forEach.call(nodes, function (node) {
      if (node.kSlideshowStop) node.kSlideshowStop();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-video-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    if (root.dataset.kVcInit === 'true') return;
    root.dataset.kVcInit = 'true';
    var track = root.querySelector('[data-k-vc-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-k-vc-card]'));
    if (!track || !cards.length) return;
    var count = cards.length;
    var current = 0;
    var timer = null;

    /* Spread the cards across the full width of the section instead of stacking them
       in the middle — matches the reference site, where the side cards sit next to the
       active one rather than behind it. */
    function stepSize() {
      var cardWidth = cards[0].offsetWidth || 320;
      var rings = Math.max(1, Math.floor(count / 2));
      var available = track.clientWidth / 2 - cardWidth * 0.45;
      return Math.max(cardWidth * 0.45, Math.min(cardWidth * 1.08, available / rings));
    }

    function render() {
      var step = stepSize();
      cards.forEach(function (card, i) {
        var offset = i - current;
        var half = count / 2;
        if (offset > half) offset -= count;
        if (offset < -half) offset += count;
        var distance = Math.abs(offset);
        var scale = distance === 0 ? 1 : distance === 1 ? 0.85 : 0.78;
        card.style.transform = 'translate(calc(-50% + ' + offset * step + 'px), -50%) scale(' + scale + ')';
        card.style.zIndex = String(count - distance);
        card.style.filter = distance === 0 ? 'none' : 'brightness(0.6)';
        card.classList.toggle('is-active', distance === 0);
        var video = card.querySelector('video');
        if (video) {
          if (distance === 0) {
            var playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          } else if (!video.paused) {
            video.pause();
          }
        }
      });
    }

    function goTo(index) {
      current = ((index % count) + count) % count;
      render();
    }

    function restartTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      if (root.dataset.autoplay === 'true' && count > 1) {
        var seconds = parseInt(root.dataset.interval, 10) || 5;
        timer = setInterval(function () {
          goTo(current + 1);
        }, seconds * 1000);
      }
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function (event) {
        if (i !== current) {
          event.preventDefault();
          event.stopPropagation();
          goTo(i);
          restartTimer();
        }
      });
      var muteButton = card.querySelector('[data-k-vc-mute]');
      var video = card.querySelector('video');
      if (muteButton && video) {
        muteButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          video.muted = !video.muted;
          muteButton.classList.toggle('is-muted', video.muted);
        });
      }
    });

    var startX = null;
    track.addEventListener(
      'touchstart',
      function (event) {
        startX = event.touches[0].clientX;
      },
      { passive: true }
    );
    track.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var delta = event.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(delta) > 40) {
        goTo(delta < 0 ? current + 1 : current - 1);
        restartTimer();
      }
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(render, 150);
    });

    render();
    restartTimer();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-k-video-carousel]');
    Array.prototype.forEach.call(roots, initCarousel);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-kailash"]) return;
  try {
    
document.querySelectorAll('.artk__copy').forEach((button) => {
  button.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(button.dataset.url);
      const tip = button.querySelector('.artk__copy-tip');
      tip.hidden = false;
      setTimeout(() => {
        tip.hidden = true;
      }, 2000);
    } catch (error) {
      window.prompt('Copy this link:', button.dataset.url);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
